//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TimelineItemCard from "./utils/timeline-card.vue";
import TimelineCardFooter from "./utils/timeline-card-footer.vue";
import TimelineConsolidatedRequest from "./timeline-client-application-request/timeline-consolidated-request.vue";
import { getRequestPackageBadgeType } from "@Shared/@Utils/utils";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TimelineClientApplicationRequest",
  components: {
    TimelineItemCard,
    TimelineCardFooter,
    TimelineConsolidatedRequest
  },
  props: {
    createdAt: {
      type: String,
      default: ""
    },
    updatedAt: {
      type: String,
      default: ""
    },
    completedAt: {
      type: String,
      default: ""
    },
    metadata: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      expanded: false
    };
  },
  computed: {
    message() {
      return this.metadata.message;
    },
    subject() {
      return this.metadata.subject;
    },
    signers() {
      return this.metadata.signers;
    },
    atLeastOneDocGenerated() {
      return this.metadata.atLeastOneDocGenerated;
    },
    institution() {
      return this.metadata.institution;
    },
    cardHeader() {
      const {
        type
      } = this;
      const typeMap = {
        "e-sign": this.$t("application.eSignPackage"),
        "bank-statements": this.$t("application.bankStatements"),
        "consolidated-request": this.$t("application.consolidatedRequest"),
        noa: this.$t("application.noa")
      };
      return typeMap[type];
    },
    actionText() {
      if (this.type === "bank-statements") return this.$t("global.words.submitted");
      if (this.completedAt) return this.$t("global.words.completed");
      if (this.updatedAt === this.createdAt) return this.$t("global.words.created");
      return this.$t("global.words.updated");
    },
    dateAt() {
      if (this.completedAt) return this.completedAt;
      return this.updatedAt;
    },
    isBankStatementRequest() {
      return this.type === "bank-statements";
    },
    succeededIcon() {
      return this.atLeastOneDocGenerated ? "fa-check-circle text-success" : "fa-times-circle text-danger";
    },
    isConsolidatedRequest() {
      return this.type === "consolidated-request";
    }
  },
  methods: {
    getBadgeType(status) {
      return getRequestPackageBadgeType(status);
    },
    toggleExpand() {
      this.expanded = !this.expanded;
    }
  }
});